var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"align-center pt-8"},[_c('v-container',{staticClass:"logo"},[_c('div',{staticClass:"pl-6 py-8 headline"},[_vm._v(" "+_vm._s(_vm.$t('base.components.welcomeTo'))+" ")]),_c('v-img',{attrs:{"src":_vm.orgLogo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }